import { render, staticRenderFns } from "./MegaMenu.vue?vue&type=template&id=6a56f9cc&scoped=true&"
import script from "./MegaMenu.vue?vue&type=script&lang=js&"
export * from "./MegaMenu.vue?vue&type=script&lang=js&"
import style0 from "./MegaMenu.vue?vue&type=style&index=0&id=6a56f9cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a56f9cc",
  null
  
)

export default component.exports